import React from 'react';

export default function TopCheckoutbanner() {
  return (
    <svg
      width='32'
      height='8'
      viewBox='0 0 32 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='4' cy='4' r='4' fill='#F45952' />
      <circle cx='16' cy='4' r='4' fill='#DFB94E' />
      <circle cx='28' cy='4' r='4' fill='#5AB748' />
    </svg>
  );
}
